<style lang="scss">
    .OperateLhc-3 {
        h6.title {
            padding:3px 5px; text-align:center; background-color:#f3655e; color:#fff;
        }
    }
</style>
<template>
    <div class="OperateLhc-3">
        <!-- <div class="l-flex">
            <div class="l-flex-4">
                <group :client="client" :list="Table[0]" :length="4"  :radio="true" :transmit="false" :double-line="true" @pick="AloneTransfer" />
            </div>
            <div class="l-flex-1" />
        </div>
        <BoardFast :client="client" :group="[0]" transmit="six-balls" :radio="true" :limit="limit" :double="has_double_odds" />
        <div class="o-mt">
            <group :client="client" :list="Table[1]" :length="5" show-total="end" />
            <BoardFast :client="client" :group="[1]" type="lhc" :step="true" :outbtn="true" />
        </div> -->
        <template v-if="OperateAuth.bind === 2">
            <el-radio-group v-model="active" size="mini">
                <el-radio-button v-for="(item,index) in tabs" :key="item" :label="item">{{ index }}</el-radio-button>
            </el-radio-group>
            <div class="o-mt">
                <div v-for="(item, index) in tabs" :key="index" v-show="OperateAuth.bind != 3">
                    <template v-if="active === item">
                        <group :client="client" :list="Table[item]" :length="5" :win="false" show-total="end" :total="totals[item]" />
                        <BoardFast v-if="OperateAuth.bind === 2" :client="client" :group="[item]" :step="true" :default-step="0.01" />
                    </template>
                </div>
            </div>
        </template>
        <template v-else-if="OperateAuth.bind === 1 || OperateAuth.bind === 3">
            <div class="l-flex">
                <div class="l-flex-4">
                    <group :client="client" :list="Table[0]" :length="4"  :radio="true" :transmit="false" :double-line="true" @pick="AloneTransfer" />
                </div>
                <div class="l-flex-1" />
            </div>
            <BoardFast v-show="OperateAuth.bind === 3" :client="client" :group="[0]" transmit="six-balls" :radio="true" :limit="limit" :double="has_double_odds" />
            <!-- <div class="o-mt">
                <group :client="client" :list="Table[1]" :length="5" show-total="end" />
                <BoardFast :client="client" :group="[1]" type="lhc" :step="true" :outbtn="true" />
            </div> -->
        </template>
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateLhc3',
    mixins: [CommonMix],
    data() {
        return {
            interval: ['2rem', 3, 3, 3, 3],
            limit: undefined,
            has_double_odds: false,
            active: 31,
            tabs: {'三全中': 31, '三中二': 41, '二全中': 61, '二中特': 71},
            totals: {
                '31': {amount: 0, count: 0},
                '41': {amount: 0, count: 0},
                '61': {amount: 0, count: 0},
                '71': {amount: 0, count: 0},
            },
        }
    },
    props: {
        client: {}
    },
    computed: {
        oldItemGroup() {
            return [
                this.client.play.find((item) => item.id == 282),
                this.client.play.find((item) => item.id == 283),
                this.client.play.find((item) => item.id == 285),
                this.client.play.find((item) => item.id == 286)
            ]
        }
    },
    methods: {

    },
    components: {
        Group
    }
}
</script>
